import * as Types from "../schemaTypes.generated";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type SetCurrentOrganisationMutationVariables = Types.Exact<{
  username: Types.Scalars["String"];
  selected_organisation_id: Types.Scalars["Int"];
}>;

export type SetCurrentOrganisationMutation = {
  __typename?: "mutation_root";
} & {
  update_app_users?: Types.Maybe<
    { __typename?: "app_users_mutation_response" } & {
      returning: Array<
        { __typename?: "app_users" } & Pick<
          Types.App_Users,
          "selected_organisation_id"
        >
      >;
    }
  >;
};

export const SetCurrentOrganisationDocument = gql`
  mutation SetCurrentOrganisation(
    $username: String!
    $selected_organisation_id: Int!
  ) {
    update_app_users(
      where: { id: { _eq: $username } }
      _set: { selected_organisation_id: $selected_organisation_id }
    ) {
      returning {
        selected_organisation_id
      }
    }
  }
`;

export function useSetCurrentOrganisationMutation() {
  return Urql.useMutation<
    SetCurrentOrganisationMutation,
    SetCurrentOrganisationMutationVariables
  >(SetCurrentOrganisationDocument);
}
